import React from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Icon,
  Tooltip,
} from '@material-ui/core';

import EventTemplateAutocomplete from '../../../../../../forms/EventTemplateAutocomplete';
import styles from './styles';

const useStyles = makeStyles(styles);

export const FormEventsComponent = (props) => {
  const {
    formRequest,
    setFormRequest,
  } = props;
  const classes = useStyles();

  const handleTypeChange = (e) => {
    const changedValue = e.target.value;
    if (changedValue === 'Single') {
      if (formRequest.eventTemplates.length > 1) {
        // remove all but one workflow
        setFormRequest({
          ...formRequest,
          eventTemplates: [formRequest.eventTemplates[0]],
        });
      }
    }
    setFormRequest({
      ...formRequest,
      type: changedValue,
    });
  };

  const handleChangeEventTemplates = (e, value) => {
    let changedValue = [];
    if (value) {
      changedValue
      = Array.isArray(value)
          ? value
          : [value];
    }

    setFormRequest({
      ...formRequest,
      eventTemplates: changedValue,
      validation: {
        ...formRequest.validation,
        eventTemplates: {
          hasChanged: true,
          isValid: changedValue.length > 0,
          message: formRequest.validation.eventTemplates.message,
        },
      },
    });
  };

  return (
    <div>
      <FormControl component="fieldset" className={classes.typeFormControl} margin="normal">
        <FormLabel required>Form Type</FormLabel>
        <RadioGroup aria-label="type" name="type" value={formRequest.type} onChange={handleTypeChange}>
          <FormControlLabel
            value="Single"
            control={<Radio />}
            label={(
              <div className={classes.iconTextInline}>
                <span>Single Form</span>
                <Tooltip title="Users only have one form option to fill out"><Icon color="secondary" className={classes.helpIcon} fontSize="small">help_outline</Icon></Tooltip>
              </div>
            )}
          />
          <FormControlLabel
            value="Select"
            control={<Radio />}
            label={(
              <div className={classes.iconTextInline}>
                <span>Select Form to Submit</span>
                <Tooltip title="Users can select from a list of forms, but only submit one form"><Icon color="secondary" className={classes.helpIcon} fontSize="small">help_outline</Icon></Tooltip>
              </div>
            )}
          />
          <FormControlLabel
            value="Multiple"
            control={<Radio />}
            label={(
              <div className={classes.iconTextInline}>
                <span>Select Multiple Forms to Submit</span>
                <Tooltip title="Users can select from a list of forms, and submit multiple forms"><Icon color="secondary" className={classes.helpIcon} fontSize="small">help_outline</Icon></Tooltip>
              </div>
            )}
          />
        </RadioGroup>
      </FormControl>

      <EventTemplateAutocomplete
        multiple={formRequest.type !== 'Single'}
        error={
            !formRequest.validation.eventTemplates.isValid
              && !!formRequest.validation.eventTemplates.hasChanged
            }
        helperText={!formRequest.validation.eventTemplates.isValid
          ? formRequest.validation.eventTemplates.message
          : 'Select the Workflows(s) to be used in the form'}
        value={formRequest.type !== 'Single'
          ? formRequest.eventTemplates
          : formRequest.eventTemplates[0]}
        onChange={handleChangeEventTemplates}
      />

    </div>
  );
};

FormEventsComponent.propTypes = {
  formRequest: PropTypes.object,
  setFormRequest: PropTypes.func,
};
FormEventsComponent.defaultProps = {
  formRequest: null,
  setFormRequest: () => {},
};

export default FormEventsComponent;
